// Mock data para o Criador de Currículos

export const mockResumeData = {
  personalInfo: {
    fullName: 'João da Silva',
    desiredPosition: 'Desenvolvedor Frontend',
    phone: '(11) 99999-9999',
    email: 'joao.silva@email.com',
    city: 'São Paulo',
    state: 'SP'
  },
  objective: 'Profissional dedicado buscando oportunidade na área de desenvolvimento web, com foco em criar interfaces modernas e responsivas.',
  experiences: [
    {
      id: '1',
      company: 'Tech Solutions',
      position: 'Desenvolvedor Junior',
      startDate: '01/2023',
      endDate: 'Atual',
      current: true,
      description: 'Desenvolvimento de aplicações web utilizando React e Node.js.'
    },
    {
      id: '2',
      company: 'Startup XYZ',
      position: 'Estagiário de TI',
      startDate: '06/2022',
      endDate: '12/2022',
      current: false,
      description: 'Suporte técnico e desenvolvimento de scripts automatizados.'
    }
  ],
  education: [
    {
      id: '1',
      institution: 'Universidade de São Paulo',
      course: 'Ciência da Computação',
      degree: 'Bacharelado',
      startDate: '2020',
      endDate: '2024',
      current: true
    }
  ],
  skills: [
    { id: '1', name: 'JavaScript', level: 'Avançado' },
    { id: '2', name: 'React', level: 'Intermediário' },
    { id: '3', name: 'HTML/CSS', level: 'Avançado' },
    { id: '4', name: 'Git', level: 'Intermediário' },
    { id: '5', name: 'Node.js', level: 'Básico' }
  ],
  languages: [
    { id: '1', name: 'Português', level: 'Nativo' },
    { id: '2', name: 'Inglês', level: 'Intermediário' },
    { id: '3', name: 'Espanhol', level: 'Básico' }
  ]
};

export const emptyResumeData = {
  personalInfo: {
    fullName: '',
    desiredPosition: '',
    phone: '',
    email: '',
    city: '',
    state: ''
  },
  objective: '',
  experiences: [],
  education: [],
  skills: [],
  languages: []
};

export const skillLevels = [
  'Básico',
  'Intermediário',
  'Avançado',
  'Expert'
];

export const languageLevels = [
  'Básico',
  'Intermediário',
  'Avançado',
  'Fluente',
  'Nativo'
];

export const degreeOptions = [
  'Ensino Médio',
  'Técnico',
  'Tecnólogo',
  'Bacharelado',
  'Licenciatura',
  'Pós-graduação',
  'MBA',
  'Mestrado',
  'Doutorado'
];

export const brazilianStates = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
  'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
  'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
];
